/**
 * 福卡平台相关
 */

import {localget} from './storage'
import consts from "Utils/consts";
import {FUKA_CONFIG} from 'Config/index'
import { Toast } from 'vant';
import api from 'Plugins/api';
import dsBridge from 'Utils/bridge'
import router  from '@/business/plugins/router';

/**
 * 是否是福卡平台
 * @returns {boolean}
 */
export function isFuka() {
  const param = localget('loginType') || ''
  return FUKA_CONFIG.fukaTag == param
}

/**
 * 福卡支付
 * @param orderId 订单id
 * @param orderType 订单类型
 */
export function toPayForFuka(orderId, orderType) {
  Toast.loading({message: '支付中...', loadingType: 'spinner', forbidClick: true, duration: 0});
  api['common/fukaPay']({orderId, orderType}).then(res => {
    const { cashierAddress } = res.data || {};
    if (cashierAddress) {
      Toast.loading({message: '打开福卡收银台...', loadingType: 'spinner', forbidClick: true, duration: 0});

      // 30秒内没有返回结果，30秒后清除loading, 防止一直显示
      const timer30 = setTimeout(() => (Toast.clear(), Toast.fail({message: '支付超时，请稍后再试', duration: 3000})), 30000);

      dsBridge.call('paymentAsyncNotify', {url: cashierAddress}, res => {
        console.log("dsBridge - toPayForFuka - resp:", res)
        clearTimeout(timer30)
        Toast.clear();
        const result = typeof res === 'string' ? JSON.parse(res || '{}') : (res || {})
        // {
        // "code": 1, // -1 ⽀付成功; 1 ⽀付取消; 0 ⽀付失败; 2 交易处理中
        // "message": "⽀付取消"
        // }

        if (result.code === -1) {
          Toast.success({message: '支付成功', duration: 3000});
          router.push({
            path: '/pay/paySuccess',
            query: {
              orderId,
              orderType
            }
          })
        } else if (result.code === 0) {
          Toast.fail({message: '支付失败，请稍后再试', duration: 3000});
        } else if (result.code === 1 || result.code === 2) {
          // Toast.fail({message: '支付取消', duration: 3000});
        } else {
          Toast.fail({message: result.message || '支付异常，请稍后再试', duration: 3000});
        }
      })
    } else {
      Toast.fail({message: '支付失败', duration: 3000});
    }
  }).catch(ignore => {// 接口异常无需处理程序会自动处理
    console.log('toPayForFuka-catch', ignore)
  }).finally(() => {
    // Toast.clear();
  });
}